<script lang="ts">
	export let authorString: string;
	export let dateline: string;
</script>

<div class="Byline">
	<div class="Byline__author">
		<span class="Byline__author__text">{authorString}</span>
	</div>
	<div class="Byline__dateline">
		<span class="Byline__dateline__text">{dateline}</span>
	</div>
</div>

<style lang="scss">
	@use '$styles/mq' as *;
	@use '$styles/colors' as *;
	.Byline {
		background: var(--theme-primary);
		padding: 32px auto;
		color: var(--theme-secondary);
		font-family: var(--brand-font-ui-cn);
		text-align: center;
	}

	.Byline__author {
		margin-bottom: 0px;
	}

	.Byline__dateline__text {
		color: $gray-5;
		font-weight: 300;
		font-size: 0.8rem;
	}
</style>
